import { makeStyles } from "tss-react/mui";
import { CustomStylePropsInterface } from "types/styleType";
import { commonStyles } from "./commonStyles";

export const getUseStyles = (
	styles = (theme: any, custom: any) => {
		return {};
	},
	withCommonStyle = true,
	custom?: CustomStylePropsInterface
) => {
	return makeStyles()((theme) => {
		return withCommonStyle ? { ...commonStyles(theme), ...styles(theme, custom) } : { ...styles(theme, custom) };
	});
};

export default getUseStyles;
